import KformComponent from '../kform-component';

export default class CustomComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentCustom | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
	}
}
